import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2024 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">SquareTrade</h4>
            <h5 className="vertical-timeline-element-subtitle">Brisbane, CA</h5>
            <p>
              Full-stack Development, Data Management and Analysis, MVP Design and Implementation, API Development
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2021 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Seasonal Competition Staff</h3>
            <h4 className="vertical-timeline-element-subtitle">Varsity</h4>
            <h5 className="vertical-timeline-element-subtitle">Downey, CA</h5>
            <p>
              Event Operations. Customer Service, Crowd Management, Adaptability and Flexibility
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Summer 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">SquareTrade</h4>
            <h5 className="vertical-timeline-element-subtitle">Brisbane, CA</h5>
            <p>
              Full-stack Development, Technical Leadership, Task Breakdown and Planning, Team Collaboration, Project Ownership
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Summer 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Data Engineer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">SquareTrade</h4>
            <h5 className="vertical-timeline-element-subtitle">Brisbane, CA</h5>
            <p>
              Full-stack Development, Team Collaboration, API Development
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2022 - 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Chemistry Learning Assistant</h3>
            <h4 className="vertical-timeline-element-subtitle">Cal Poly SLO</h4>
            <h5 className="vertical-timeline-element-subtitle">San Luis Obispo, CA</h5>
            <p>
              Academic Support, Collaboration, Peer Mentor and Tutor
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Team Member</h3>
            <h4 className="vertical-timeline-element-subtitle">Cal Poly Corporation</h4>
            <h5 className="vertical-timeline-element-subtitle">San Luis Obispo, CA</h5>
            <p>
              Customer Service, Food Preparation, Quality Control, Time Management, Multitasking
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Summer 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Cheer Staff</h3>
            <h4 className="vertical-timeline-element-subtitle">United Spirit Association - Varsity</h4>
            <h5 className="vertical-timeline-element-subtitle">Downey, CA</h5>
            <p>
              Teaching, Mentoring, Leadership and Communication Development
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2019 - 2020"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Cashier</h3>
            <h4 className="vertical-timeline-element-subtitle">The Cookie Element</h4>
            <h5 className="vertical-timeline-element-subtitle">Yorba Linda, CA</h5>
            <p>
              Customer Service, Team Collaboration, Organization and Inventory Management, Product Presentation
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;